var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.CellComponent, _vm._b({
    tag: "component",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'component', {
    mode: _vm.mode,
    employer: _vm.employer,
    matchings: _vm.matchings,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer,
    date: _vm.date,
    time: _vm.time
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }